<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      userInfo: ''
    }
  },
  // mounted(){
  //   this.loginGo()
  // },
  // mounted: {
  //   loginGo(){
  //     if( this.userInfo == '' ) {
  //       this.$router.push({path:'/login'})
  //     }
  //   },
  // },
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue